var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { CloseButton, CloseButtonSpacer } from '../tools/components';
import { a11y } from './strings';
const StyledWrapper = styled.div `
  background-color: ${({ theme: { colors } }) => colors.white};
  border: 1px solid ${({ theme: { colors } }) => colors['gray-300']};
  box-shadow: 0 2px 4px -2px rgba(0, 0, 0, 0.16),
    0 5px 8px -4px rgba(0, 0, 0, 0.16);
  position: relative;
  border-radius: 4px;

  ${({ theme: { media }, isFullScreenSmDown }) => isFullScreenSmDown
    ? `
            ${media.down('sm')} {
                border-radius: unset;
                width: 100%;
            }
        `
    : ``}
`;
const Card = (_a) => {
    var { closeButton = true, children, onClickCloseButton, isFullScreenSmDown, className, ariaLabelCloseButton = closeButton ? a11y.ariaLabelCloseButton : undefined } = _a, others = __rest(_a, ["closeButton", "children", "onClickCloseButton", "isFullScreenSmDown", "className", "ariaLabelCloseButton"]);
    return (React.createElement(StyledWrapper, Object.assign({ isFullScreenSmDown: isFullScreenSmDown, "data-testid": "mui-card", className: className }, others),
        closeButton && (React.createElement(CloseButtonSpacer, { isFullScreenSmDown: isFullScreenSmDown })),
        React.createElement(Box, { p: "md" }, children),
        closeButton && (React.createElement(CloseButton, { "data-testid": "close-button", "data-track-elem": "icon", "data-track-name": "Close", "data-track-trigger": "close", onClick: onClickCloseButton, ariaLabel: ariaLabelCloseButton }))));
};
export { Card };
//# sourceMappingURL=Card.js.map